import { Repository } from "../../utils";

export class RiskScoreInputRepository extends Repository {
  apiUrl = '/api/v1/risk_score_inputs/';

  async createInput(newInput: object, csrfToken: string): Promise<any> {
    return await fetch(
      this.apiUrl,
      {
        method: "POST",
        body: JSON.stringify(newInput),
        headers: {
          "X-CSRFToken": csrfToken,
          "Content-Type": "application/json"
        }
      }
    );
  }

  async updateLevel(id: number, newLevelId: number, csrfToken: string): Promise<any> {
    return await fetch(
      this.apiUrl + id + "/",
      {
        method: "PATCH",
        body: JSON.stringify({level: newLevelId}),
        headers: {
          "X-CSRFToken": csrfToken,
          "Content-Type": "application/json"
        }
      }
    );
  }
}

export class RiskScoreInputLevelRepository extends Repository {
  apiUrl = '/api/v1/risk_score_input_levels/';

  async getByType(type: string): Promise<any> {
    const response = await fetch(this.apiUrl + "?type=" + type);
    return response.status === 200 ? await response.json().then(data => data):[];
  }
}
